'use strict';

var classChecks = require('../../common/var/classChecks');

var isArray = classChecks.isArray;

function isArrayOrInherited(obj) {
  return obj && obj.constructor && isArray(obj.constructor.prototype);
}

module.exports = isArrayOrInherited;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/array/internal/isArrayOrInherited.js
// module id = 1250
// module chunks = 0